import smLogo from "@assets/images/smo-blue.svg";
import smLoginImage from "@assets/images/smop-login.svg";
import smResetPass from "@assets/images/smop-reset.svg";
import { makeStyles } from "@material-ui/core/styles";
import React, { Fragment, useEffect, useState } from "react";
import SVG from "react-inlinesvg";

const useStyles = makeStyles(
  theme => ({
    logo: {
      display: "block",
      height: "70px",
      marginRight: "1rem"
    },
    logoText: {
      fontSize: "1.5rem"
    },
    logoWrapper: {
      alignItems: "center",
      display: "flex",
      height: 70,
      marginBottom: theme.spacing(3)
    },
    mainPanel: {
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2)
      },
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      justifyContent: "center",
      padding: theme.spacing(6),
      width: "100vw"
    },
    mainPanelContent: {
      [theme.breakpoints.up("xs")]: {
        width: "100%"
      },
      [theme.breakpoints.up("sm")]: {
        width: 328
      },
      "@media (min-width: 1440px)": {
        display: "flex",
        width: 800
      },
      background: "#fff",
      border: "1px solid #c7c7c7",
      margin: "auto",
      padding: "2rem",
      position: "relative",
      width: "100%"
    },
    root: {
      [theme.breakpoints.up("lg")]: {
        gridTemplateColumns: "376px 1fr"
      },
      "@media (min-width: 1440px)": {
        gridTemplateColumns: "520px 1fr"
      },
      display: "grid",
      gridTemplateColumns: "1fr",
      height: "100vh",
      overflow: "hidden",
      width: "100vw"
    },
    sideLeft: {
      [theme.breakpoints.up("xs")]: {
        width: "100%"
      },
      "& svg": {
        [theme.breakpoints.up("xs")]: {
          height: "150px",
          marginBottom: theme.spacing(2),
          width: "280px"
        },
        "@media (min-width: 1440px)": {
          height: "215px"
        },
        display: "block"
      },
      "@media (min-width: 1440px)": {
        marginRight: "4rem",
        width: "50%"
      },
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end"
    },
    sideRight: {
      width: "100%"
    }
  }),
  {
    name: "Layout"
  }
);

const Layout: React.FC = props => {
  const { children } = props;
  const classes = useStyles(props);
  const [logoText, setLogoText] = useState(null);
  const [loginLayout, setLoginLayout] = useState(false);
  const [defaultImage, setDefaultImage] = useState(false);
  // paths with layout wrapper
  const loginPaths = ["reset-password", "new-password"];

  useEffect(() => {
    let layoutChecker = false;

    // setting logo text
    if (window.location.pathname.includes("reset-password")) {
      setDefaultImage(false);
      setLogoText("Forgot Password");
    } else if (window.location.pathname.includes("new-password")) {
      setDefaultImage(false);
      setLogoText("Reset your Password");
    } else {
      setDefaultImage(true);
      setLogoText("Welcome Back!");
    }

    // check current path for layout wapper
    loginPaths.forEach(item => {
      if (window.location.pathname.includes(item)) {
        layoutChecker = true;
      }
    });

    setLoginLayout(layoutChecker);
  }, [window.location.pathname]);

  return (
    <Fragment>
      {loginLayout ? (
        <div className={classes.root}>
          <div className={classes.mainPanel}>
            <div className={classes.mainPanelContent}>
              <div className={classes.sideLeft}>
                {defaultImage ? (
                  <>
                    <SVG src={smLoginImage} />
                  </>
                ) : (
                  <>
                    <SVG src={smResetPass} />
                  </>
                )}
              </div>
              <div className={classes.sideRight}>
                <div className={classes.logoWrapper}>
                  <img className={classes.logo} src={smLogo} />
                  <p className={classes.logoText}>{logoText}</p>
                </div>
                {children}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>{children}</div>
      )}
    </Fragment>
  );
};

Layout.displayName = "Layout";
export default Layout;
